// extracted by mini-css-extract-plugin
export default {"MainCont":"Mixing_MainCont__B35vQ","LeftCont":"Mixing_LeftCont__PYl6n","RightCont":"Mixing_RightCont__0vm-z"};